var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYrsofexp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3299,
    cy: 19.9901,
    r: 19.9901,
    fill: "#36C93A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0534 13.7591H31.0389V31.6723H11.633V13.7591H14.6185V12.2664H16.1113V13.7591H26.5606V12.2664H28.0534V13.7591ZM29.5462 15.2519H28.0534V16.7447H29.5462V15.2519ZM26.5606 15.2519H16.1113V16.7447H26.5606V15.2519ZM14.6185 15.2519H13.1258V16.7447H14.6185V15.2519ZM13.1258 30.1796H29.5462V18.2374H13.1258V30.1796ZM11.633 12.2664V10.7736H10.1402V27.194H8.64746V9.28085H11.633V7.78809H13.1258V9.28085H23.5751V7.78809H25.0679V9.28085H28.0534V10.7736H25.0679V12.2664H23.5751V10.7736H13.1258V12.2664H11.633ZM16.1113 24.2085V22.7157H17.6041V24.2085H16.1113ZM19.0968 24.2085V22.7157H20.5896V24.2085H19.0968ZM22.0824 24.2085V22.7157H23.5751V24.2085H22.0824ZM25.0679 24.2085V22.7157H26.5606V24.2085H25.0679ZM16.1113 27.194V25.7013H17.6041V27.194H16.1113ZM19.0968 27.194V25.7013H20.5896V27.194H19.0968ZM22.0824 27.194V25.7013H23.5751V27.194H22.0824ZM19.0968 21.223V19.7302H20.5896V21.223H19.0968ZM22.0824 21.223V19.7302H23.5751V21.223H22.0824ZM25.0679 21.223V19.7302H26.5606V21.223H25.0679Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8842,
    height: 23.8842,
    fill: "white",
    transform: "translate(8.64746 7.78809)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYrsofexp);
export default __webpack_public_path__ + "static/media/yrsofexp.bdba61014af09a05cb1bd8d6a4f5552f.svg";
export { ForwardRef as ReactComponent };